<template>
  <div class="custom-split-table">
    <v-row>
      <v-col cols="12">
        <v-simple-table dark>
          <thead>
            <tr>
              <th class="text-left">Split</th>
              <th v-for="n in levelCounts" :key="n">Level {{ n }}</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="n in levelCounts" :key="n">
              <td>
                {{ n }}
                <v-tooltip top color="black" max-width="300">
                  <template v-slot:activator="{ on, attrs }">
                    <v-icon color="#708AA7" small v-bind="attrs" v-on="on">mdi-information-outline</v-icon>
                  </template>
                  <span>Split level {{ n }} information</span>
                </v-tooltip>
              </td>
              <td v-for="level in levelCounts" :key="level">
                <v-text-field
                  v-if="shouldShowTextField(n, level)"
                  :value="getSplitValue(n, level - 1)"
                  @input="updateSplitValue(n, level - 1, $event)"
                  :disabled="n === 1 && level === 1"
                  outlined dense dark hide-details
                  background-color="#1B2A4A"
                />
              </td>
            </tr>
          </tbody>
        </v-simple-table>
      </v-col>
    </v-row>
  </div>
</template>

<script>

export default {
  name: 'CommissionSplitTable',
  props: {
    levelCounts: {
      type: Number,
      required: true,
    },
    splitData: {
      type: Object,
      required: true,
    },
    tutorial: {
      type: Object,
      required: true,
      default: null
    },
  },
  methods: {
    shouldShowTextField(row, level) {
      return level <= (this.splitData[row.toString()]?.length || 0);
    },

    getSplitValue(row, level) {
      return this.splitData[row.toString()]?.[level] || 0;
    },

    updateSplitValue(row, level, value) {
      const newSplitData = { ...this.splitData };
      if (!newSplitData[row.toString()]) {
        newSplitData[row.toString()] = [];
      }
      newSplitData[row.toString()][level] = parseFloat(value) || 0;
      this.$emit('input', newSplitData);
      this.$emit('update:splitData', newSplitData);
    }
  }
};
</script>